export interface ICharge {
  hashRate: string;
  date: number;
  amount: string;
  rate: string;
}

export type TSortChargeByHeaderTitle = keyof ICharge;

export enum ECalculationPeriods {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
}
